const initialState = {
  'byId': new Map(),
  'loading': false,
};

export function workItemsReducer(state = initialState, action) {
  switch (action.type) {
    case 'INSERT_WORK_ITEM':
      return {
        ...state,
        byId: new Map([[action.payload.id, action.payload], ...state.byId]),
      };
    case 'UPDATE_WORK_ITEM':
      state.byId.set(action.payload.id, action.payload);
      return {
        ...state,
        byId: new Map([...state.byId]),
      };
    case 'DELETE_ALL_WORK_ITEMS':
      return {
        ...state,
        byId: new Map(),
      };
    case 'DELETE_WORK_ITEM':
      state.byId.delete(action.payload.id);
      return {
        ...state,
        byId: new Map([...state.byId]),
      };
    case 'UPDATE_WORK_ITEMS': {
      return {
        ...state,
        byId: new Map([...state.byId, ...action.payload]), 
      };
    }
    case 'WORK_ITEMS_LOADING': {
      return {
        ...state,
        loading: {
          ...state.loading,
          [action.meta]: action.payload,
        }
      };
    }
    case 'DELETE_PROJECT':
      if (action.meta == 'deleted') {
        state.byId.forEach((workItemId, workItem, map) => {
          if (workItem.track_project_id == action.payload.id) {
            map.delete(workItemId);
          }
        });
      }
      return {
        ...state,
        byId: new Map([...state.byId]),
      };
    default:
      return state;
  }
}
